import * as React from "react";

export const NotFound: React.FC = () => {
  return (
    <>
      <h1>Stránka nenalezena (Chyba 404)</h1>
    </>
  );
};
